export const debugLog = (...args) => {
    if (window.__DEBUG__ === true) {
        console.log(...args);
    }
};